// extracted by css-extract-rspack-plugin
export default {"DismissIconButtonWrapper":"KF47X"};